export { default } from './TeamChatFieldAnchor';
